import { select } from '@angular-redux/store';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '@app/core/constants/core.constants';
import { ModalService, UtilitiesService } from '@app/core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-points-tutorial',
  templateUrl: './points-tutorial.component.html',
  styleUrls: ['./points-tutorial.component.less']
})
export class PointsTutorialComponent implements OnInit {
  @select((appState) => appState.auth.isLoggedIn) isLoggedIn?: Observable<boolean>;
  config = [
    {
      "step": 1,
      "header": "Earn Free Food when you\nOrder Online or Scan",
      "featureImage": "tableTent",
      "content": "Earn 10 points for every $1 spent ordering online or\nscanning at the restaurant"
    },
    {
      "step": 2,
      "header": "Earn Free Food when you\nOrder Online or Scan",
      "featureImage": "trophy",
      "tutorialLinkText": "What Can I Earn?",
      "tutorialLinkPath": '/rewards/what-can-i-earn',
      "content": "Redeem points for rewards"
    },
    {
      "step": 3,
      "header": "Earn Free Food when you\nOrder Online or Scan",
      "featureImage": "phoneredeem",
      "content": "Redeem rewards in online orders\nor scan at the restaurant"
    },
    {
      "step": 4,
      "header": "Earn Free Food when you\nOrder Online or Scan",
      "featureImage": "point_expires",
      "content": "Points expire after 6 months of no account activity."
    }
  ];
  step: number;
  loading = false;
  isUserSignedIn: boolean;
  constructor(private modalService: ModalService, private router: Router) { }

  ngOnInit(): void {
    this.step = 1;
    this.isLoggedIn.subscribe(
      val => {
        this.isUserSignedIn = val;
      }
    );
  }
  stepCTA() {

  }
  moveStep(increment: number) {
    const newStep = this.step + increment;
    this.step = newStep < 1 ? 1: (newStep > this.config.length ? this.config.length : newStep );
  }
  goToStep(step: number) {
    this.step = step;
  }
  onSwipe($event) {    
    if($event.direction == Hammer.DIRECTION_LEFT) {
      this.moveStep(1);
    } else if ($event.direction == Hammer.DIRECTION_RIGHT){
      this.moveStep(- 1);
    }
    console.log($event);
  }
  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  showSignupModal(): void {
    this.showModal(this.modalService.getSignupModalSelector());
  }
  goToScreen(step) {
    this.modalService.hideModal();
    setTimeout(() => {
      this.router.navigate([this.config[step-1].tutorialLinkPath]);
    }, 100);
  }
  redirectToRewards() {
    this.router.navigate(['/rewards'], {queryParams: 
      UtilitiesService.generateQueryParams([Constants.ROUTE_ON_POINTS], [true])});
  }
}
